export default __webpack_public_path__ + "static/media/laundryHelper.7a8db5da.svg";